import React from "react";
import styled from "styled-components";
import { Button } from "../../../../shared/button/Button";
import theme from "../../../../../theme/theme";
import { GeneralLink } from "../../../../../utils/generateLink";
import { ReactComponent as ArrowRight } from "../../../../../assets/icon/arrowRight.svg";

interface IProps {
  labelColor: string;
  buttonBcgColor: string;
  buttonTextColor: string;
}

const Container = styled.div`
  z-index: 50;
  margin: auto 0;
  padding: 30px 8px;
  max-width: 345px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;

  & button {
    margin-top: 8px;
  }

  & svg {
    margin-top: 0;
  }

  & path {
    fill: ${theme.colors.white};
  }
`;

const Title = styled.h2<{ $color: string }>`
  color: ${(props) => props.$color};
  font-family: Lato, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
`;

const Subtitle = styled.p<{ $color: string }>`
  color: ${(props) => props.$color};
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
`;

export const RegisterViewingSuccess: React.FC<IProps> = ({
                                                           labelColor,
                                                           buttonBcgColor,
                                                           buttonTextColor,
                                                         }) => {
  return (
    <Container>
      <Title $color={labelColor}>Rejestracja zakończona pomyślnie</Title>
      <Subtitle $color={labelColor}>Możesz się teraz zalogować</Subtitle>
      <Button
        text={"Przejdź do logowania"}
        link={GeneralLink.LOGIN}
        backgroundColor={buttonBcgColor}
        color={buttonTextColor}
        size={"tiny"}
        maxWidth={"180px"}
        icon={<ArrowRight/>}
      />
    </Container>
  );
};
